import { MediaImage, MediaVideo } from '@/components/atoms/media'
import { MediaDataTypes } from '@/components/atoms/media/MediaData'
import MediaVideoEmbed from '@/components/atoms/media/MediaVideoEmbed'
import { MediaTypes } from '@/types/enums'
import { Box } from '@chakra-ui/react'
import { buildImageUrl } from './imageSharpUrlBuilder'

export function renderMedia(
  mediaData: MediaDataTypes,
  imageCropSizeAlias: Partial<Record<string, string>>,
  viewportWidthFactor: Partial<Record<string, number>>,
  draggable?: boolean,
  objectFit?: any,
): JSX.Element | undefined {
  switch (mediaData.type) {
    case MediaTypes.Video:
      return (
        <Box margin='0 auto' width='100%'>
          <MediaVideo
            {...mediaData}
            hasBorderRadius={true}
            forceControls={true}
          />
        </Box>
      )
    case MediaTypes.Image:
      return (
        <MediaImage
          {...mediaData}
          cropSizeAlias={imageCropSizeAlias}
          imageUrlBuilder={buildImageUrl}
          hasBorderRadius={true}
          viewportWidthFactor={viewportWidthFactor}
          draggable={draggable}
          objectFit={objectFit}
        />
      )
    case MediaTypes.Embed:
      return <MediaVideoEmbed {...mediaData} />
    default:
      return undefined
  }
}
